/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-23 16:34:09
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-23 17:48:23
 * @FilePath: /unifyxp-v2-store-portal/src/pages/FileDetail/Components/index.ts
 */
export { default as EditInput } from './Input';
export { default as InstanceModal } from './InstanceModal';
